var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssProps),attrs:{"id":"app"}},[_c('div',{class:{ overlay: _vm.overlay }}),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.showLoader),expression:"showLoader",modifiers:{"fullscreen":true,"lock":true}}]},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2a67762","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 